import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["hiddenField", "select"];

  connect() {
    this.selectTarget.addEventListener(
      "change",
      this.onFacilityComponentChange
    );
  }

  disconnect() {
    this.selectTarget.removeEventListener(
      "change",
      this.onFacilityComponentChange
    );
  }

  onFacilityComponentChange = () => {
    if (this.selectTarget.value == "") return;

    this.hiddenFieldTarget.value = true;
  };
}
